import React from 'react'
import { useTranslation } from 'react-i18next'

import { getDate } from '../../../../utils/dateTime'
import IconMasterCard from '../../../../svg/mc.svg'

export const BillingHistoryTableRow = ({ item, getInvoice }) => {
    const { t } = useTranslation()

    let price = item.paymentMethodCode === 'FREE' ? '0' : null
    if (item.currency === 'USD') {
        price = `$${item.total}`
    } else if (item.currency === 'RUB') {
        price = `${item.total} ₽`
    }

    return (
        <li className="table-list__item">
            <ul>
                <li className="col col-1">
                    {getDate(item.saleDate)}
                    <div className="sm">{item.externalOrderReference}</div>
                </li>
                <li className="col col-2">
                    {/*Premium plan: */}
                    <span className="dark">{item.product.name}</span>
                </li>
                <li className="col col-3">
                    {item.paymentMethodCode === 'FREE' ? (
                        t('_common.not_required')
                    ) : (
                        <div className="payment-method">
                            <img className="payment" src={IconMasterCard} alt="" />
                            <span>
                                {item.paymentMethod} ****{item.cardLastDigits}
                            </span>
                        </div>
                    )}
                </li>
                <li className="col col-4">{item.orderStatus}</li>
                <li className="col col-5">
                    <span className="big dark">{price}</span>
                </li>
                {item.isTest || item.orderStatus !== 'COMPLETE' ? null : (
                    <li className="col col-6">
                        <a
                            className="invoice-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => getInvoice(item)}
                        >
                            {t('_common.view_invoice')}
                        </a>
                    </li>
                )}
            </ul>
        </li>
    )
}
